import { json } from './api'

export type SupportContactSettings = {
  whatsapp_number: string | null
  whatsapp_enabled: boolean
  whatsapp_prefill_default: string
}

const endpoint = '/v1/support/platform/contact-settings/'
const payload = (value: SupportContactSettings): RequestInit => ({ method: 'PATCH', body: JSON.stringify(value) })

export const getSupportContactSettings = () => json<SupportContactSettings>(endpoint)
export const saveSupportContactSettings = (settings: SupportContactSettings) =>
  json<SupportContactSettings>(endpoint, payload(settings))
